import * as Logos from '@atlaskit/logo';
import { DN10A, N0 } from '@atlaskit/theme/colors';
import { AppKey, ProductKey } from '@atlassiansox/bxpkit-core';
import styled from '@emotion/styled';
import React from 'react';
import { Product } from '../model';
import { useSignUpFormConfig } from '../../../../../hook';

export function Logo(product: Product, isWhiteBackground: boolean) {
  const { bundle } = useSignUpFormConfig();
  const productkey = product.product;
  const productContent =
    product.productContent && product.productContent.length
      ? product.productContent.find(
          (content) => content.productKey === productkey
        )
      : null;
  const isJiraFamily =
    bundle === 'jira' && productkey === ProductKey.JIRA_SOFTWARE;
  const textColor = isWhiteBackground ? DN10A : N0;
  const appearance = isWhiteBackground ? 'brand' : 'inverse';
  const Logostyle = {
    size: 'xlarge',
    appearance
  };

  if (productContent && productContent.atlasKitLogoName) {
    // Try and get Atlaskit Logo from product data
    if (productContent.atlasKitLogoName) {
      const allLogos = { ...Logos };
      const ProductLogoClass = allLogos[productContent.atlasKitLogoName];
      if (!!ProductLogoClass) {
        return <ProductLogoClass key={productkey} {...Logostyle} />;
      }
    }
  }
  // @ts-ignore

  if (Object.values(AppKey).includes(productkey)) {
    return (
      <CMSLogo key={productkey} src={productContent.productLogoWhiteUrl} />
    );
  }

  // for team central, get the logo from magnolia
  const useCMSLogo =
    productkey === ProductKey.TEAM_CENTRAL ||
    productkey === ProductKey.JIRA_PRODUCT_DISCOVERY ||
    productkey === ProductKey.FABRIC ||
    productkey === ProductKey.BEACON;

  if (useCMSLogo && !!productContent.productLogoWhiteUrl) {
    return (
      <CMSLogo key={productkey} src={productContent.productLogoWhiteUrl} />
    );
  }

  if (isJiraFamily) {
    return <Logos.JiraLogo key={productkey} {...Logostyle} />;
  }

  switch (productkey) {
    case 'com.atlassian.bitbucket':
      return <Logos.BitbucketLogo key={productkey} {...Logostyle} />;
    case 'confluence.ondemand':
      return <Logos.ConfluenceLogo key={productkey} {...Logostyle} />;
    case 'jira-core.ondemand':
      return <Logos.JiraWorkManagementLogo key={productkey} {...Logostyle} />;
    case 'jira-servicedesk.ondemand':
      return (
        <Logos.JiraServiceManagementLogo key={productkey} {...Logostyle} />
      );
    case 'jira-software.ondemand':
      return <Logos.JiraLogo key={productkey} {...Logostyle} />;
    case 'jira-workmanagement.ondemand':
      return <Logos.JiraWorkManagementLogo key={productkey} {...Logostyle} />;
    case 'opsgenie':
      return <Logos.OpsgenieLogo key={productkey} {...Logostyle} />;
    case 'statuspage':
      return <Logos.StatuspageLogo key={productkey} {...Logostyle} />;
    case 'trello':
      return <Logos.TrelloLogo key={productkey} {...Logostyle} />;
    case 'compass':
      return <Logos.CompassLogo key={productkey} {...Logostyle} />;
    default:
      return productContent && productContent.productName ? (
        <h2 style={{ color: textColor }}>{productContent.productName}</h2>
      ) : (
        <Logos.AtlassianLogo key={productkey} {...Logostyle} />
      );
  }
}

const CMSLogo = styled.img`
  height: 48px;
`;
